module.exports = __webpack_public_path__ + "img/analytic_like.ac45d621.svg";